"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.addYouTubeAttributes = exports.getId = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _PlayArrow = _interopRequireDefault(require("@material-ui/icons/PlayArrow"));

var _Utils = require("../../Utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getId = function getId(x) {
  return x.split('/').pop();
};

exports.getId = getId;

var addYouTubeAttributes = function addYouTubeAttributes(item) {
  var copy = _objectSpread({}, item);

  copy.id = getId(copy.video);
  copy.img = "https://img.youtube.com/vi/".concat(copy.id, "/0.jpg");
  return copy;
};

exports.addYouTubeAttributes = addYouTubeAttributes;

var Lightbox = function Lightbox(_ref) {
  var children = _ref.children,
      label = _ref.label,
      lists = _ref.lists;

  var renderPlayButton = function renderPlayButton(video) {
    return function (props) {
      var handleOpen = props.handleOpen,
          open = props.open;

      var dialogButton = /*#__PURE__*/_react["default"].createElement(_Fab["default"], {
        color: "primary",
        onClick: handleOpen,
        "aria-label": label,
        "aria-pressed": open
      }, /*#__PURE__*/_react["default"].createElement(_PlayArrow["default"], null));

      return typeof children === 'function' ? children(video, dialogButton, props) : dialogButton;
    };
  };

  return lists.map(addYouTubeAttributes).map(function (v) {
    return /*#__PURE__*/_react["default"].createElement(_Utils.Dialog, {
      key: v.id,
      title: v.title,
      description: v.description,
      ButtonComponent: renderPlayButton(v),
      maxWidth: "md",
      fullWidth: true
    }, function (_ref2) {
      var setOpen = _ref2.setOpen;
      return /*#__PURE__*/_react["default"].createElement(_Utils.VideoPaper, {
        setOpen: setOpen,
        video: v
      });
    });
  });
};

Lightbox.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  label: _propTypes["default"].string,
  lists: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    title: _propTypes["default"].string,
    video: _propTypes["default"].string.isRequired
  })).isRequired
};
Lightbox.defaultProps = {
  children: undefined,
  label: 'Click to open video dialog'
};
var _default = Lightbox;
exports["default"] = _default;